(function () {
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').
  /* expects either mbox and name or userId and name; and expects isGroup (which is treated as a function
   to keep the value a boolean and not a string)
   Size is not used right now as an attribute because the css is always going to display at 48px */
  directive('wsAvatar', ['Utils', '$http', 'Api', 'Person', function wsAvatar(Utils, $http, Api, Person) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        userId: "@",
        personId: "@",
        imageUrl: "@",
        name: "@",
        mbox: "@",
        isGroup: "&",
        size: "@",
        centered: "@"
      },
      templateUrl: "modules/common/directives/avatar/avatar.html",
      link: function link(scope) {
        var pixelSizes = {
          'large': 128,
          'medium': 64,
          'small': 48
        };
        scope.size = scope.size || "small";
        scope.centered = scope.centered && scope.centered.toLowerCase() === "true";
        getAvatar();
        var updateAvatar = _.debounce(function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.$apply(getAvatar);
          }
        }, 1000);

        //If name, email, or userId changes, try and get avatar again
        scope.$watch("name", updateAvatar);
        scope.$watch("mbox", updateAvatar);
        scope.$watch("userId", updateAvatar);
        scope.$watch("imageUrl", updateAvatar);
        function getAvatar() {
          if (scope.imageUrl) {
            scope.imgUrl = scope.imageUrl;
          } else if (scope.userId) {
            $http.get(Api.url("/users/" + scope.userId + "/img", true), {
              params: {
                "s": pixelSizes[scope.size]
              },
              cache: true
            }).then(function (result) {
              scope.imgUrl = result.data.imageUrl;
            },
            //if error is returned (no image), show initials instead
            function () {
              showInitials(scope.name);
            });
          }

          // if person is given, see if it matches user, or persona has email with image
          else if (scope.personId && !scope.isGroup()) {
            var config = {
              params: {
                "s": pixelSizes[scope.size]
              },
              cache: true
            };
            Person.getPersonImage(scope.personId, config).then(function (result) {
              if (result) {
                scope.imgUrl = result.imageUrl;
              } else {
                showInitials(scope.name);
              }
            },
            //if error is returned, show initials instead
            function () {
              showInitials(scope.name);
            });
          }

          // if mbox is given, see if gravatar image exists
          else if (scope.mbox) {
            var email = scope.mbox.replace("mailto:", "");
            $http.get(Api.url("/avatar", true, true), {
              params: {
                "name": scope.name,
                "email": email,
                "s": pixelSizes[scope.size]
              },
              cache: true
            }).then(function (result) {
              scope.imgUrl = result.data.imageUrl;
            },
            //if error is returned (no image), show initials instead
            function () {
              showInitials(scope.name);
            });
          } else {
            showInitials(scope.name);
          }
        }
        function showInitials(name) {
          scope.initials = getInitials(name);
          scope.imgUrl = null;
        }
        function getInitials(string) {
          if (!string) {
            return;
          }
          var arr = string.split(/ +/),
            res = '',
            added = 0;
          for (var i = 0; i < arr.length && added < 3; i++) {
            if (arr[i].length > 0 && arr[i][0] !== '(') {
              res += arr[i][0];
              added += 1;
            }
          }
          return res.toUpperCase();
        }
      }
    };
  }]);
})();
